import {
  StatesFacadeService,
  DispatchersFacadeService,
} from '../dispatchers-facade.service';
import { ServiceConfigurationLoadedStateManager } from '../service-configuration-loaded.service';
import {
  ServiceRequestLoadedStateManager,
  DraftServiceRequestLoadedStateManager,
  ServiceRequestUpdatedStateManager,
  ServiceRequestCreatedStateManager,
  FormsDefinedStateManager,
  DraftServiceRequestSavedStateManager,
  InvalidFlowStateManager,
  SuccessfulFlowStateManager,
  FlowStateManager,
  InvalidServiceRequestSubmitStateManager,
  PaymentGatewayStateManager,
  PaymentConfirmedStateManager,
  PaymentErrorStateManager,
  WorkflowStartedStateManager,
  ServicePageLandedStateManager,
} from '../service-request-loaded.service';
import { ApplicantStateService } from '../../ApplicantState.service';
import { AnalyticsListenersService } from '../../analytics-management/analytics.listeners.service';
import { ProcedureInstanceListenersService } from '../../analytics-management/procedure-instance-listeners.service';
import { ServiceMetadataLoadedStateManager } from '../service-metadata-loaded-state.service';

export const SERVICE_SHARED_PROVIDERS = [
  {
    provide: 'stateFacadeService',
    useExisting: StatesFacadeService,
  },
  {
    provide: 'applicantStateService',
    useExisting: ApplicantStateService,
  },
  {
    provide: 'dispatcherService',
    useExisting: DispatchersFacadeService,
  },

  {
    provide: 'serviceConfigurationLoadedStateManager',
    useExisting: ServiceConfigurationLoadedStateManager,
  },
  {
    provide: 'serviceRequestLoadedStateManager',
    useExisting: ServiceRequestLoadedStateManager,
  },
  {
    provide: 'serviceRequestUpdatedStateManager',
    useClass: ServiceRequestUpdatedStateManager,
  },
  {
    provide: 'serviceRequestCreatedStateManager',
    useClass: ServiceRequestCreatedStateManager,
  },
  {
    provide: 'invalidServiceRequestSubmitManager',
    useClass: InvalidServiceRequestSubmitStateManager,
  },
  {
    provide: 'draftServiceRequestSavedStateManager',
    useExisting: DraftServiceRequestSavedStateManager,
  },
  {
    provide: 'draftServiceRequestLoadedStateManager',
    useExisting: DraftServiceRequestLoadedStateManager,
  },
  {
    provide: 'analyticsListenersService',
    useExisting: AnalyticsListenersService,
  },
  {
    provide: 'procedureInstanceListenersService',
    useClass: ProcedureInstanceListenersService,
  },
  {
    provide: 'formsDefinedStateManager',
    useExisting: FormsDefinedStateManager,
  },
  {
    provide: 'invalidFlowManager',
    useExisting: InvalidFlowStateManager,
  },
  {
    provide: 'successfulFlow',
    useExisting: SuccessfulFlowStateManager,
  },
  { provide: 'flow', useExisting: FlowStateManager },
  {
    provide: 'paymentGateway',
    useExisting: PaymentGatewayStateManager,
  },
  {
    provide: 'paymentConfirmed',
    useExisting: PaymentConfirmedStateManager,
  },
  {
    provide: 'paymentError',
    useExisting: PaymentErrorStateManager,
  },
  {
    provide: 'workflowStarted',
    useExisting: WorkflowStartedStateManager,
  },
  {
    provide: 'servicePageLanded',
    useExisting: ServicePageLandedStateManager,
  },
  {
    provide: 'serviceMetadataLoaded',
    useExisting: ServiceMetadataLoadedStateManager,
  },
  StatesFacadeService,
  ApplicantStateService,
  DispatchersFacadeService,
  ServiceConfigurationLoadedStateManager,
  ServiceRequestLoadedStateManager,
  ServiceRequestUpdatedStateManager,
  ServiceRequestCreatedStateManager,
  InvalidServiceRequestSubmitStateManager,
  DraftServiceRequestLoadedStateManager,

  AnalyticsListenersService,
  FormsDefinedStateManager,
  InvalidFlowStateManager,
  SuccessfulFlowStateManager,
  FlowStateManager,

  PaymentGatewayStateManager,
  PaymentConfirmedStateManager,
  PaymentErrorStateManager,
  WorkflowStartedStateManager,
  ServicePageLandedStateManager,
  ServiceMetadataLoadedStateManager,
];
